import { IconBase } from "./iconBase.js";
import { jsx } from "@emotion/react/jsx-runtime";
//#region src/arrowUp.tsx
var ArrowUp = ({ type, ...rest }) => /* @__PURE__ */ jsx(IconBase, {
	viewBox: "0 0 24 24",
	...rest,
	children: type === "stroke" ? /* @__PURE__ */ jsx("path", {
		d: "M6 10.0606L12 4M12 4L18 10.0606M12 4V20",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}) : /* @__PURE__ */ jsx("path", {
		d: "M11.25 20V5.82324L6.53322 10.5879C6.24188 10.8822 5.76705 10.8849 5.47267 10.5938C5.17839 10.3024 5.17563 9.82758 5.46682 9.5332L11.4668 3.47266L11.582 3.37793C11.7048 3.29546 11.8499 3.25 12 3.25C12.2002 3.25 12.3924 3.33038 12.5332 3.47266L18.5332 9.5332L18.584 9.58984C18.823 9.88563 18.8034 10.3205 18.5274 10.5938C18.2513 10.8668 17.8167 10.8816 17.5235 10.6396L17.4668 10.5879L12.75 5.82324V20C12.75 20.4142 12.4142 20.75 12 20.75C11.5858 20.75 11.25 20.4142 11.25 20Z",
		fill: "currentColor"
	})
});
//#endregion
export { ArrowUp };
